import { render, staticRenderFns } from "./gzhFans.vue?vue&type=template&id=073534f8&scoped=true"
import script from "./gzhFans.vue?vue&type=script&lang=js"
export * from "./gzhFans.vue?vue&type=script&lang=js"
import style0 from "./gzhFans.vue?vue&type=style&index=0&id=073534f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073534f8",
  null
  
)

export default component.exports